import { render, staticRenderFns } from "./IngresoDocumentosS2.vue?vue&type=template&id=199b6f92&"
import script from "./IngresoDocumentosS2.vue?vue&type=script&lang=js&"
export * from "./IngresoDocumentosS2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports